import { render, staticRenderFns } from "./LoadingTable.vue?vue&type=template&id=0996554e&"
import script from "./LoadingTable.vue?vue&type=script&lang=js&"
export * from "./LoadingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports